<!-- <div class="h-100" *ngIf="web_url">
  <iframe
    class=" h-100"
    [src]="web_url"
    allowfullscreen
  ></iframe>
</div> -->


<!-- <div>
  <img
  *ngIf="image"
    [src]="image"
    [class.boreder-bottom-16]="roundedBottom"
    class="img-fluid"
  />
</div> -->
  <div class="p-0 w-100 d-flex align-items-center justify-content-center rounded-3">
    <div class="card p-0 m-0 position-relative shadow-none w-100" style="max-width: 560px">
      <img [src]="emptyImage" class="card-img" alt="empty">
      <div class="card-img-overlay p-0">
        <div class="position-absolute start-0 end-0">
          <div  *ngIf="image" class="card m-0 p-0 shadow-none rounded-0">
            <img [src]="image" alt="empty" class="card-img">
          </div>

        </div>
      </div>
    </div>
  </div>

<!-- <div [id]="'widgetContainer' + idHtml" class="h-100"></div> -->
